import { InjectionToken, NgModule } from '@angular/core';
import { PHOTO_EDITOR_5_CONFIG } from '../configs/vendor/photo-editor-sdk-5.config';
import { INBOX_COLUMNS } from '../configs/inbox/columns.config';


export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export interface AppConfig {
    photoEditor: any;
    defaults?: {
        dashboard: {
            widgets: {
                inboxOverview: {
                    settings: {
                        columns: any,
                        linesPerPage: number
                    }
                }
            }
        }
    }
}

export const APP_DI_CONFIG: AppConfig = {
    photoEditor: PHOTO_EDITOR_5_CONFIG,
    defaults: {
        dashboard: {
            widgets: {
                inboxOverview: {
                    settings: {
                        columns: INBOX_COLUMNS,
                        linesPerPage: 5
                    }
                }
            }
        }
    }
};

@NgModule({
    providers: [
        { provide: APP_CONFIG, useValue: APP_DI_CONFIG },
    ]
})
export class AppConfigModule {}
